import { useAddAccess } from '@/modules/Users/queries/add-access';
import { useRemoveAccess } from '@/modules/Users/queries/remove-access';
import { useInvalidateUserQueries } from '@/shared/hooks/useInvalidateUserMutations';
import { useCallback } from 'react';

type UseToggleUserAccessProps = {
  onSettled?: () => void;
};

export const useToggleUserAccess = ({
  onSettled,
}: UseToggleUserAccessProps = {}) => {
  const { mutate: addAccess, isLoading: isLoadingAddAccess } = useAddAccess();
  const { mutate: removeAccess, isLoading: isLoadindRemoveAccess } =
    useRemoveAccess();
  const invalidateUserQueries = useInvalidateUserQueries();

  const onChange = useCallback(
    (checked: boolean, userId: number) => {
      if (checked) {
        addAccess(userId, {
          onSuccess: invalidateUserQueries,
          onSettled,
        });
      } else {
        removeAccess(userId, {
          onSuccess: invalidateUserQueries,
          onSettled,
        });
      }
    },
    [addAccess, invalidateUserQueries, onSettled, removeAccess],
  );

  return {
    onChange,
    isLoading: isLoadingAddAccess || isLoadindRemoveAccess,
    isLoadingAddAccess,
    isLoadindRemoveAccess,
  };
};
